import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { showMessageBar, hideMessageBar } from "../redux/slices/messageBarSlice";

export const useMessageBarController = () => {
  const dispatch = useDispatch();

  const showMessage = useCallback(
    (variant, message, otherProps = {}) => {
      dispatch(showMessageBar({ variant, message, otherProps }));
    },
    [dispatch]
  );

  const hideMessage = useCallback(() => {
    dispatch(hideMessageBar());
  }, [dispatch]);

  return { showMessage, hideMessage };
};
